import styled from 'styled-components';

import { COLORS } from '@theme/colors';

export const OuterContainer = styled.div`
  padding: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4em;
  letter-spacing: 0.02em;
`;

export const Container = styled.div<{ isVisible: boolean }>`
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  height: 100%;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  right: 0;
  background: ${COLORS.WHITE};

  &::before {
    content: '';
    width: 50px;
    height: 35px;
    background: linear-gradient(to left, ${COLORS.WHITE}, rgba(255, 255, 255, 0));
    position: absolute;
    left: -50px;
    top: 0;
    pointer-events: none;
  }
`;

export const Button = styled.button`
  border-radius: 50%;
  width: 24px;
  height: 24px;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4em;
  letter-spacing: 0.02em;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    path {
      fill: ${({ active }: { active: boolean }) => (active ? COLORS.BLACK : COLORS.DARK_GREY)};
    }
  }
`;

export const Trigger = styled(Button)`
  svg {
    path {
      fill: ${COLORS.BLACK};
    }
  }
`;
